import React from 'react';
import { Link } from 'react-router-dom';
import AuthBottom from 'components/AuthBottom';
import AuthTop from 'components/AuthTop';
import AuthWrapper from 'components/AuthWrapper';
import AutoPlayingVideo from 'components/AutoPlayingVideo';
import { getWelcomeVideoRate, setWelcomeVideoRate } from 'utils/localStorage';
import BenefitsVideoPoster from '../assets/benefits-video-poster.jpg';
import BenefitsVideo from '../assets/benefits-video.mp4';
import MemberBenefitSlides from './MemberBenefitSlides';
import './DefaultLandingPage.css';

// How many time to watch/skip video before it stops autoplaying
const WATCH_THRESHOLD = 1;
const SKIP_THRESHOLD = 3;

function handleSkipped() {
  progressWatchRate(1 / SKIP_THRESHOLD);
}

function handleWatched() {
  progressWatchRate(1 / WATCH_THRESHOLD);
}

function progressWatchRate(amount) {
  const rate = getWelcomeVideoRate();
  const newRate = Math.min(1.0, Math.round(100 * (rate + amount) + 1) / 100);
  setWelcomeVideoRate(newRate);
}

function isWatchRateMet() {
  return getWelcomeVideoRate() >= 1.0;
}

function DefaultLandingPage() {
  const autoPlay = !isWatchRateMet();
  return (
    <div className="default-landing-page">
      <h1 className="sr-only">Sign Up or Sign In to Wind Creek Casino</h1>
      <AuthWrapper>
        <AuthTop>
          <AutoPlayingVideo
            aria-label="Introduction video"
            aria-describedby="intro-video-transcript"
            defaultAutoPlay={autoPlay}
            defaultMuted={true}
            className="intro-video-container"
            controls
            poster={BenefitsVideoPoster}
            fallback={<MemberBenefitSlides />}
            onSkipped={handleSkipped}
            onWatched={handleWatched}
            ratioToWatch={0.8}
          >
            <source src={BenefitsVideo} type="video/mp4" />
          </AutoPlayingVideo>
          <div className="sr-only" id="intro-video-transcript">
            {
              "Thanks for visiting WindCreekCasino.com. We're glad you're here! "
            }
            {
              'WindCreekCasino.com is a social casino, a place where you can play your favorite games online, interact with your friends, play in tournaments, check your rewards account, and so much more! '
            }
            {
              "But the best thing about WindCreekCasino.com is that it's always free to play! "
            }
            {
              "And while you're playing, you'll be earning WScore points, which can be used in the WStore to purchase real rewards such as FREE play, food credits, drawing entries, and more! "
            }
            {
              'All of which can be redeemed at your favorite Wind Creek location on your next visit. '
            }
            {'Gambling problem? Call 1-800-GAMBLER '}
          </div>
        </AuthTop>
        <AuthBottom>
          <Link to="/login" className="btn button-color-yellow btn-block">
            <span>Sign in</span>
          </Link>
        </AuthBottom>
      </AuthWrapper>
    </div>
  );
}

export default DefaultLandingPage;
